import { useEffect, useState } from 'react'
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { isLogin } from '../../Helper/Functions';
import { Context } from '../../Helper/Context';
import { SubscriptionModal } from '../../Helper/Modal';
import { C, fBody, LogoMark, Wordmark } from '../../Shared/Brand';
import { dashboardStyles } from '../../Shared/DashboardUI';

export default function Header() {
    const param = useParams()
    const navigate = useNavigate()
    const { profile, verifyAuth } = Context()
    const authValidate = async () => {
        const log = await isLogin();
        if (!log) { navigate('/login'); return }
        if (!profile.userId) { verifyAuth() }
    }
    const [userInfo, setUserInfo] = useState(null);
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (!token) return;

        const fetchUserInfo = async () => {
          try {
            const res = await fetch(
              `${process.env.REACT_APP_API_BASE_URI}/api/users/getRoi-history`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const json = await res.json();

            const data = json?.data || [];

            if (data.length === 0) {
              setUserInfo(null);
              return;
            }

            const user = data[0]?.userId;

            setUserInfo({
              userId: user?._id,
              username: user?.username,
              name: user?.name,
            });
          } catch (err) {
            console.error("Error fetching user:", err);
          }
        };

        fetchUserInfo();
      }, [token]);
    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("xp_impersonating");
        localStorage.removeItem("xp_impersonated_username");
        localStorage.removeItem("xp_admin_return_url");

        navigate("/login");
    };

    const impersonating = localStorage.getItem("xp_impersonating") === "true";
    const impersonatedUsername = localStorage.getItem("xp_impersonated_username") || "";
    const adminReturnUrl = localStorage.getItem("xp_admin_return_url") || "";

    const returnToAdmin = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("xp_impersonating");
        localStorage.removeItem("xp_impersonated_username");
        localStorage.removeItem("xp_admin_return_url");

        let target = adminReturnUrl;
        if (target && (target.endsWith("/ba") || target.includes("/ba/"))) {
            target = target.replace(/\/ba(\/|$)/, "/bx-control-x92$1");
        }
        window.location.href = target || "/login";
    };
    useEffect(() => {
        authValidate()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [param, profile?.userId])

    return (<div className="xdb">
        <style>{dashboardStyles}</style>
        {impersonating && (
            <div style={{
                background: C.primary, color: C.tx, fontFamily: fBody, fontSize: '13px', fontWeight: 600,
                padding: '8px 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
                flexWrap: 'wrap', textAlign: 'center',
            }}>
                <span>Viewing as {impersonatedUsername || 'user'} (admin session)</span>
                <button onClick={returnToAdmin} style={{
                    background: C.tx, color: C.white, border: 'none', borderRadius: '999px',
                    padding: '4px 12px', fontFamily: fBody, fontWeight: 700, fontSize: '12px', cursor: 'pointer',
                }}>Return to Admin</button>
            </div>
        )}
        <div className="xdb-topbar">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <LogoMark size={34} />
                <Wordmark size={15} />
            </Link>

            <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <a href="#subscriptions" style={{
                    background: C.primary, color: C.dark, fontWeight: 700, fontSize: '12px',
                    padding: '9px 14px', borderRadius: '999px', textDecoration: 'none', whiteSpace: 'nowrap',
                }}>Subscription Packages</a>

                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => setProfileMenuOpen((v) => !v)}
                        style={{
                            width: '38px', height: '38px', borderRadius: '50%', border: `1px solid ${C.dbdr}`,
                            background: C.card, color: C.ltx, cursor: 'pointer', display: 'flex', alignItems: 'center',
                            justifyContent: 'center', fontFamily: fBody, fontWeight: 700, fontSize: '14px',
                        }}
                    >
                        {(userInfo?.username || profile?.email || 'U').slice(0, 1).toUpperCase()}
                    </button>
                    {profileMenuOpen && (
                        <div style={{
                            position: 'absolute', right: 0, top: '46px', width: '220px', background: C.dark2,
                            border: `1px solid ${C.dbdr}`, borderRadius: '12px', padding: '14px', zIndex: 50,
                            boxShadow: '0 12px 32px rgba(0,0,0,0.4)',
                        }}>
                            <div style={{ fontSize: '12px', color: C.ltx3, marginBottom: '2px' }}>UID: {userInfo?.username || '—'}</div>
                            <div style={{ fontSize: '12px', color: C.ltx2, marginBottom: '12px' }}>{userInfo?.name}</div>
                            <button onClick={handleLogout} style={{
                                display: 'block', width: '100%', textAlign: 'left', fontSize: '13px', color: C.down,
                                background: 'none', border: 'none', borderTop: `1px solid ${C.dbdr}`, padding: '8px 0 0',
                                cursor: 'pointer', fontFamily: fBody,
                            }}>Log Out</button>
                        </div>
                    )}
                </div>
            </div>
        </div>

        <div className="xdb-content">
            <Outlet />
        </div>
        <SubscriptionModal />
    </div>)
}
